import { en } from "./localization/en";
import { ar } from "./localization/ar";

const localization = {
  en,
  ar,
};

export default localization;
